export const InsertSectionShadow = {
  position: 'absolute',
  bottom: '0',
  left: '0',
  right: '0',
  height: 'E3',
  background: 'linear-gradient(0deg, var(--theme-common-box-dark-background) 5%, transparent 100%)',
  pointerEvents: 'none',
};